import { useMutation, useQueryClient } from '@tanstack/react-query';
import { submitMeasurementSession } from '../services/measurementService';
import type { SubmitMeasurementSessionInput, MeasurementSessionResult } from '../types/measurement';

export interface UseSubmitMeasurementSessionArgs {
  aquariumId: string;
  input: SubmitMeasurementSessionInput;
}

export function useSubmitMeasurementSession() {
  const queryClient = useQueryClient();

  return useMutation<MeasurementSessionResult, Error, UseSubmitMeasurementSessionArgs>({
    mutationFn: async ({ aquariumId, input }: UseSubmitMeasurementSessionArgs) => {
      return submitMeasurementSession(aquariumId, input);
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: ['measurements', variables.aquariumId] });
      void queryClient.invalidateQueries({
        queryKey: ['measurementSessionDefaults', variables.aquariumId],
      });
    },
  });
}
